import AccordionItem from '@atoms/AccordionItem/AccordionItem';
import { VariantType } from '@models/IAccordion';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface Props {
  items?: Array<{
    title: string;
    text?: string;
  }>;
  variant?: VariantType;
}

const Accordion = ({
  items,
  variant = 'primary',
  children,
}: PropsWithChildren<Props>) => (
  <section>
    {children ??
      items?.map(({ title, text }, index) => (
        <AccordionItem
          key={title}
          title={title}
          text={text}
          variant={variant}
          buttonClasses={classNames({
            'tw-border-t tw-border-grey-20': index === 0,
          })}
        >
          {children}
        </AccordionItem>
      ))}
  </section>
);

export default Accordion;
